import { WBBox, WBFlex, WBTypography } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import React, { useState } from 'react';
import LottieAnimation from '../LottieAnimation/LottieAnimation';
import { S3Upload } from '@admiin-com/ds-common';
import TaxTaskUpload from '../../features/components/CreateTask/TaxWorkflow/TaxUpload/TaxTaskUpload';
import TaxTypeTab from '../../features/components/CreateTask/TaxWorkflow/TaxUpload/TaxTypeTab';

interface Props {
  onGetStarted: (files: S3Upload[], isBinding: boolean) => void;
  title?: string;
  description?: string;
  buttonTitle?: string;
  loading?: boolean;
  isTax?: boolean;
}
const Onboarding: React.FC<Props> = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <WBBox>
      {props.isTax && (
        <TaxTypeTab
          activeTab={activeTab}
          handleTabChange={(event, newValue) => setActiveTab(newValue)}
        />
      )}
      <Conatiner flexDirection={'column'} alignItems={'center'} rowGap={2.5}>
        <ImagePlaceholder>
          <LottieAnimation path="/signature.lottie" />
        </ImagePlaceholder>
        <Title textAlign={'center'}>{props.title}</Title>
        <Description variant="body1" textAlign={'center'}>
          {props.description}
        </Description>
        <WBBox width="100%">
          <TaxTaskUpload
            isPDFOnly
            onChange={(files) => {
              props.onGetStarted(files, activeTab === 1);
            }}
            multiple={activeTab === 1}
          />
        </WBBox>
      </Conatiner>
    </WBBox>
  );
};
const ImagePlaceholder = styled(WBFlex)(({ theme }) => ({
  marginLeft: '25px',
  borderRadius: '100%',
  width: '200px',
  height: '100px',
  [theme.breakpoints.down('sm')]: {},
}));

const Title = styled(WBTypography)(({ theme }) => ({
  ...theme.typography.h3,
  [theme.breakpoints.down('sm')]: {
    ...theme.typography.h4,
  },
}));

const Description = styled(WBTypography)(({ theme }) => ({
  ...theme.typography.body1,
  [theme.breakpoints.down('sm')]: {
    ...theme.typography.body2,
  },
  color: theme.palette.text.secondary,
}));

const Conatiner = styled(WBFlex)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(20),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(2),
  },
}));

export default Onboarding;
